// extracted by mini-css-extract-plugin
module.exports = {"toastsHandler":"ToastsHandler_toastsHandler__3rqp0","toast":"ToastsHandler_toast__2Od73"};